// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"bf23c64b","453":"04f73166","640":"d7264df4"}[chunkId] + ".chunk.js";
};